const color = {
  primary: {
    M: '#8d1558',
  },
  secondary: {
    L: '#066b2c',
    M: '#00973a',
    XS: '#caecd7',
  },
  gray: {
    XS: '#e8e8e8',
    S: '#aaa9a9',
  },
}

const theme = {
  control: () => ({
    backgroundColor: 'white',
    display: 'flex',
    border: `1px solid ${color.gray.S}`,
    padding: '8px 2px',
    height: '42px',
    ':focus': {
      borderColor: color.primary.M,
    },
  }),
  option: () => ({
    cursor: 'pointer',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px 30px',
    ':hover': {
      background: `${color.gray.XS}`,
    },
    ':first-child': {
      paddingTop: '10px',
    },
    ':last-child': {
      paddingBottom: '10px',
    },
  }),
  multiValue: () => ({
    backgroundColor: color.secondary.XS,
    display: 'flex',
    alignItems: 'center',
    padding: '8px 15px',
    marginRight: '5px',
    ':last-child': {
      marginRight: '0',
    },
  }),
  multiValueLabel: () => ({
    color: color.secondary.M,
    maxWidth: '80px',
    height: '22px',
    justifyText: 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
  multiValueRemove: () => ({
    color: color.secondary.M,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '5px',
    ':hover': {
      cursor: 'pointer',
      color: color.secondary.L,
    },
  }),
}

export default theme
